import React from "react";
import CampaignSharedHeader from "./CampaignSharedHeader";
import { CampaignHeaderProps } from "../../interface/shared";

interface BaseCampaignHistoryProps {
  headerProps: CampaignHeaderProps;
  children: React.ReactNode; // The History Table component
}

const BaseCampaignHistory: React.FC<BaseCampaignHistoryProps> = ({
  headerProps,
  children,
}) => {
  return (
    <div className="flex flex-col gap-2 bg-slate-50/30 dark:bg-neutral-900">
      <CampaignSharedHeader {...headerProps} />
      {children}
    </div>
  );
};

export default BaseCampaignHistory;
